module.exports = __webpack_public_path__ + "static/img/wow.6ccbc55b.png";